import api from 'api'
import {
  CACHE_TAG_ACCOUNT_CONTAINER_LIST,
  CACHE_TAG_CONFIGURED_SERVICE_CONTAINER_LIST,
  CACHE_TAG_CONFIGURED_SERVICE_DETAILS,
  CACHE_TAG_GEO_ZONE_LOCATION_EXCLUSIONS,
} from 'api/cacheTagTypes'

const extendedApi = api.injectEndpoints({
  endpoints: build => ({
    addUpdateLocation: build.mutation({
      query: body => ({ url: '/api/location', method: 'POST', body }),
      // A location update changes the service-details map pin and can move container geopoints
      // (updateContainerLocation) — refetch container lists and service details
      invalidatesTags: [
        CACHE_TAG_ACCOUNT_CONTAINER_LIST,
        CACHE_TAG_CONFIGURED_SERVICE_CONTAINER_LIST,
        CACHE_TAG_CONFIGURED_SERVICE_DETAILS,
        CACHE_TAG_GEO_ZONE_LOCATION_EXCLUSIONS,
      ],
    }),
  }),
})

export const { useAddUpdateLocationMutation } = extendedApi
